<template>
    <EChart class="bank_chart" :option="chartOption" />
</template>

<script>
import { parseToMoney } from "@/utils/currency";
import { getMonthsBetweenDates } from "@/utils/getMonthsBetweenDates";
import { getWeeksBetweenDates } from "@/utils/getWeeksBetweenDates";
import numberFormatter from "@/utils/numberFormatter.js";
import moment from "moment";
import EChart from "@/components/charts/EChart.vue";
import formatData from "./formatChartData";

export default {
    name: "ChartBankMovements",
    components: { EChart },
    props: {
        startDate: { type: String, required: true },
        endDate: { type: String, required: true },
        chartData: { type: Array, default: () => [] },
    },
    computed: {
        // Rango chico (mismo mes) → eje semanal; rango más amplio → eje mensual.
        // formatData espera `dateInMonths=true` para la versión mensual.
        sameMonth() {
            return moment(this.startDate).isSame(this.endDate, "month");
        },
        labels() {
            return this.sameMonth
                ? getWeeksBetweenDates(this.startDate, this.endDate)
                : getMonthsBetweenDates(this.startDate, this.endDate);
        },
        groupedData() {
            return formatData(this.chartData, this.labels, !this.sameMonth);
        },
        chartOption() {
            return {
                grid: { left: 12, right: 12, top: 24, bottom: 48, containLabel: true },
                xAxis: { type: "category", data: this.labels },
                yAxis: {
                    type: "value",
                    position: "right",
                    axisLabel: { formatter: (value) => numberFormatter(value, 2) },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "shadow" },
                    formatter: (params) => {
                        const lines = params
                            .map((p) => `${p.seriesName}: ${parseToMoney(p.value)}`)
                            .join("<br>");
                        return `<strong>${params[0].name}</strong><br>${lines}`;
                    },
                },
                legend: { bottom: 0, type: "scroll" },
                series: this.groupedData.map((g) => ({
                    name: g.label,
                    type: "bar",
                    stack: "total",
                    itemStyle: { color: g.backgroundColor },
                    data: g.data,
                })),
            };
        },
    },
};
</script>

<style scoped>
.bank_chart {
    width: 100%;
    height: 100%;
    min-height: 240px;
}
</style>
